module.exports = __webpack_public_path__ + "static/media/drums-double-bass.e5194cfa.mp3";